<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelim-head" id="_idParaDest-4"><a id="_idTextAnchor003"></a>Acknowledgements</h1>
<p class="Prelim-text">My sincere thanks to my family for all their support and for sorting out my many problems with modern technology.</p>
<p class="Prelim-text">Staff of Willenhall Library, Coventry for help given and lots of laughter.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528954297_EPUB-4.vue?c2be78b4